import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { CustomizationComponent } from './pages/customization/customization.component';
import { ProductsComponent } from './pages/products/products.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { ArticleComponent } from './pages/article/article.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TCComponent } from './pages/t-c/t-c.component';
import { BlogsComponent } from './pages/blogs/blogs/blogs.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { LoginComponent } from './pages/login/login.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonalInformationPageComponent } from './pages/profile/personal-information-page/personal-information-page.component';
import { ChangePasswordPageComponent } from './pages/profile/change-password-page/change-password-page.component';
import { AddressesPageComponent } from './pages/profile/addresses-page/addresses-page.component';
import { AddressFormPageComponent } from './pages/profile/address-form-page/address-form-page.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { CartPageComponent } from './pages/cart/cart-page.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChooseLanguageComponent } from './pages/choose-language/choose-language.component';
import { VerifyOtpComponent } from './pages/verify-otp/verify-otp.component';
import { CreatePasswordComponent } from './pages/create-password/create-password.component';
import { redirectLangGuard } from './guards/redirect-lang.guard';
import { authGuard } from './guards/auth.guard';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { OrderConfirmationComponent } from './pages/order-confirmation/order-confirmation.component';
import { MyordersComponent } from './pages/profile/myorders/myorders.component';
import { OrderDetailsComponent } from './pages/profile/myorders/components/order-details/order-details.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: `${localStorage.getItem('lang')}/home`,
    pathMatch: 'full',
  },
  {
    path: ':lang',
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'products/:id', component: ProductDetailsComponent },
      { path: 'customization', component: CustomizationComponent },
      { path: 'products', component: ProductsComponent },
      { path: 'categories', component: CategoriesComponent },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/personal-information',
        component: PersonalInformationPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/change-password',
        component: ChangePasswordPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/addresses',
        component: AddressesPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/address/new',
        component: AddressFormPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/address/:id/edit',
        component: AddressFormPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/myorders',
        component: MyordersComponent,
        canActivate: [authGuard],
      },
      {
        path: 'profile/order-details/:id',
        component: OrderDetailsComponent,
        canActivate: [authGuard],
      },
      { path: 'wishlist', component: WishlistComponent },
      { path: 'cart', component: CartPageComponent },
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'choose-language', component: ChooseLanguageComponent },
      { path: 'verify-otp', component: VerifyOtpComponent },
      { path: 'create-password', component: CreatePasswordComponent },
      { path: 'blogs', component: BlogsComponent },
      { path: 'blogs/:id', component: ArticleComponent },

      { path: 'privacy', component: PrivacyPolicyComponent },
      { path: 't&c', component: TCComponent },
      { path: 'about', component: AboutUsComponent },
      { path: 'checkout', component: CheckoutComponent },
      { path: 'order-success/:id', component: OrderConfirmationComponent },
      { path: '**', component: NotFoundComponent },
    ],
  },
  {
    path: '**',
    canActivate: [redirectLangGuard],
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
